import { createSlice } from "@reduxjs/toolkit";
import { createThunk } from "../../crops/selector";
import { VehiclesStatuses, VehiclesStatusesState } from "./types";
import { FetchVehiclesBody } from "../commonTypes";
import { dashboardURL } from "@utils/utils";
import { applyExtraReducer } from "../../../weather";

const initialState: VehiclesStatusesState = {
	apiError: undefined,
	isApiLoading: false,
	data: {
		byStatus: [],
		count: 0
	}
}

const fetchVehiclesStatuses = createThunk<VehiclesStatuses, FetchVehiclesBody, FetchVehiclesBody>()(
	{
		url: dashboardURL('vehicleStatus'),
		method: 'POST'
	},
	(data, url) => ({ url, data })
)

const vehiclesStatusesSlice = createSlice({
	name: 'vehiclesStatusesSlice',
	initialState,
	reducers: {},
	extraReducers: builder => {
		applyExtraReducer(builder, fetchVehiclesStatuses)
	}
})

export const actions = { ...vehiclesStatusesSlice.actions, fetchVehiclesStatuses };
export default vehiclesStatusesSlice.reducer;